module.exports = __webpack_public_path__ + "img/company.eed311c9.svg";